import React from "react";

const NoImageSVG = ({
  openDropDown,
  height = "40",
  width = "40",
  type,
  style,
}) => {
  if (type === "profile") {
    return (
      <svg
        style={style}
        width={width}
        height={height}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1"
          width="98"
          height="98"
          rx="49"
          fill="#F2F3FE"
          stroke="#C8CDF3"
          strokeWidth="2"
        />
        <path
          d="M50 52C55.5228 52 60 47.5228 60 42C60 36.4772 55.5228 32 50 32C44.4772 32 40 36.4772 40 42C40 47.5228 44.4772 52 50 52Z"
          stroke="#C8CDF3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M66 68C66 63.7565 64.3143 59.6869 61.3137 56.6863C58.3131 53.6857 54.2435 52 50 52C45.7565 52 41.6869 53.6857 38.6863 56.6863C35.6857 59.6869 34 63.7565 34 68"
          stroke="#C8CDF3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      //   onClick={() => {
      //     setShowDropdown((prev) => !prev);
      //   }}

      onClick={openDropDown}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="38"
        height="38"
        rx="19"
        fill="#F2F3FE"
        stroke="#C8CDF3"
        strokeWidth="2"
      />
      <path
        d="M20 21C22.7614 21 25 18.7614 25 16C25 13.2386 22.7614 11 20 11C17.2386 11 15 13.2386 15 16C15 18.7614 17.2386 21 20 21Z"
        stroke="#C8CDF3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 29C28 26.8783 27.1571 24.8434 25.6569 23.3431C24.1566 21.8429 22.1217 21 20 21C17.8783 21 15.8434 21.8429 14.3431 23.3431C12.8429 24.8434 12 26.8783 12 29"
        stroke="#C8CDF3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoImageSVG;
